import React from 'react';
import { Icon, type IconProps } from '../icon/icon';

export type LinkIconProps = Pick<IconProps, 'icon'>;

export const LinkIcon = React.forwardRef<
  React.ElementRef<typeof Icon>,
  LinkIconProps
>(({ icon }, ref) => {
  return <Icon icon={icon} ref={ref} />;
});

LinkIcon.displayName = 'Link.Icon';
